import React from "react";
import { Box, TextField, IconButton, Typography, Paper, Button } from "@mui/material";
import { Delete, AddCircleOutline } from "@mui/icons-material";
import StringListEditor from "./StringListEditor";

const GroupedListEditor = ({ title, groups, onChange }) => {
  const updateGroupName = (index, name) => {
    const next = [...groups];
    next[index] = { ...next[index], name };
    onChange(next);
  };

  const updateGroupItems = (index, items) => {
    const next = [...groups];
    next[index] = { ...next[index], items };
    onChange(next);
  };

  const deleteGroup = (index) => {
    onChange(groups.filter((_, i) => i !== index));
  };

  const addGroup = () => {
    onChange([...groups, { name: "New Category", items: [] }]);
  };

  return (
    <Box sx={{ mb: "1rem" }}>
      <Typography variant="subtitle2" sx={{ mb: "0.25rem" }}>
        {title}
      </Typography>
      {groups.map((group, index) => (
        <Paper key={`${title}-group-${index}`} variant="outlined" sx={{ p: "0.75rem", mb: "0.75rem" }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: "0.5rem", mb: "0.5rem" }}>
            <TextField
              size="small"
              label="Category"
              value={group.name}
              onChange={(e) => updateGroupName(index, e.target.value)}
            />
            <IconButton aria-label="delete category" onClick={() => deleteGroup(index)}>
              <Delete fontSize="small" />
            </IconButton>
          </Box>
          <StringListEditor
            label={group.name || "Items"}
            items={group.items}
            onChange={(items) => updateGroupItems(index, items)}
          />
        </Paper>
      ))}
      <Button startIcon={<AddCircleOutline />} onClick={addGroup}>
        Add Category
      </Button>
    </Box>
  );
};

export default GroupedListEditor;
